export const LOGIN = "/login";
export const SIGNUP = "/signup";
export const FORGOT_PASSWORD = "/forgot-password";
export const ADMIN_CHOICE = "/admin-choice";
export const ADD_TEST_PERSON = "/add-test-person";
export const EDIT_TEST_PERSON = "/edit-test-person";
export const VIEW_TEST_PERSON = "/view-test-person";
export const USER_LIST = "/user-list";
export const PERSON_DASHBOARD = "/person-dashboard";
export const TEST_HISTORY = "/test-history";
export const TUG_SIDE_INFO = "/tug-side-info";
export const TUG_FRONT_INFO = "/tug-front-info";
export const HOW_TO_TEST_TUG_FRONT = "/how-to-test-tug-front";
export const HOW_TO_TEST_TUG_SIDE = "/how-to-test-tug-side";
export const ACTIVITY_MONITORING = "/activity-monitoring";
export const ACTIVITY_TREND = "/activity-trend";
export const MOBILITY_REPORT = "/mobility-report-view";
export const VITALS = "/vitals";
export const ACTION_PLAN_REPORT = "/action-plan-report/:slug";
export const MOBILITY_REPORT_SHARED = "/mobility-report-shared/:slug";
export const GAZE_METRICS_REPORT = "/gaze-metrics-report";

export const PEOPLE_STATS = "/people-stats";
export const CHANGE_PASSWORD = "/change-password";
export const STS_SIDE_INFO = "/sts-side-info";
export const HOW_TO_TEST_STS_SIDE = "/how-to-test-sts-side";
